import { Component, computed, inject, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { noSoloEspacios } from '../../../clientes/pages/clientes-form-component/validations';
import { AuthLayoutComponent } from '../auth-layout/auth-layout';
import { ActivatedRoute, Router } from '@angular/router';
import { RestorePasswordService } from '../../services/restore-password.service';
import { RestorePassword } from '../../services/restore-password.interface';
import { ThemeService } from '@/app/core/services/theme/theme.service';
import { UserStateService } from '@/app/core/states/user_id/user-state.service';

@Component({
  selector: 'app-create-new-password',
  standalone: true,
  imports: [ReactiveFormsModule, AuthLayoutComponent, MatIconModule],
  templateUrl: './create-new-password.html',
  styleUrl: './create-new-password.scss',
})
export class CreateNewPassword implements OnInit {
  private passwordService = inject(RestorePasswordService);
  private formBuilder = inject(FormBuilder);
  private themeService = inject(ThemeService);
  private router = inject(Router);
  private userState= inject(UserStateService)

  token!: string | null;
   
  protected submitted = false;
  protected showPassword = false;
  protected showConfirmPassword = false;
  protected themeContent = this.themeService.themeContent;
  protected newPasswordContent = computed(() => this.themeContent()?.authComponent.createNewPasswordComponent);

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.queryParamMap.subscribe((params) => {
      this.token = params.get('key');
    });
  }

  private passwordMatchValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const password = control.get('password');
      const confirmPassword = control.get('newPasword');

      if (!password || !confirmPassword) {
        return null;
      }

      if (password.value !== confirmPassword.value) {
        return { passwordMismatch: true };
      }

      return null;
    };
  }

  onSubmit() {
    this.submitted = true;

    if (this.formCreateNewPasword.invalid) {
      return;
    }

    const restorePasswordData: RestorePassword = {
      password: this.password?.value!,
      confirmPassword: this.newPasword?.value!,
      token: this.token || '',
    };

    if (!this.token) {
      this.token = this.userState.getToken();
      if(this.token){
        restorePasswordData.token = this.token;
        this.passwordService.restorePassword(restorePasswordData).subscribe({
          next: () => {
            this.router.navigate(['/message'], {
              queryParams: {
                title: '¡Contraseña establecida exitosamente !',
                message: 'Ahora puedes iniciar sessión',
                buttonText: 'Iniciar',
                redirectTo: '/iniciar',
              },
            })
          },
          error: (error) => {
            console.error('Error al restaurar la contraseña:', error);
          }
        })
      }  
    } else {
      this.passwordService.restorePassword(restorePasswordData).subscribe({
        next: () => {
          this.router.navigate(['/iniciar']);
          this.userState.clear()
        },
        error: (error) => {
          console.error('Error al restaurar la contraseña:', error);
        }
      });
    }
  }

  formCreateNewPasword = this.formBuilder.group(
    {
      password: new FormControl('', [
        Validators.required,
        noSoloEspacios(),
        Validators.pattern(/^[A-Za-z\d@$!%*?&.]{6,}$/),
      ]),
      newPasword: new FormControl('', [Validators.required, noSoloEspacios()]),
    },
    { validators: this.passwordMatchValidator() }
  );

  get password() {
    return this.formCreateNewPasword.get('password');
  }
  get newPasword() {
    return this.formCreateNewPasword.get('newPasword');
  }

  get passwordsDoNotMatch(): boolean {
    return (
      !!this.formCreateNewPasword.hasError('passwordMismatch') &&
      !!this.submitted &&
      !!this.password?.value &&
      !!this.newPasword?.value
    );
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  toggleConfirmPasswordVisibility() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }
}